import { useCallback, useState } from "react";

export interface ActionDialogPayload {
  title: string;
  description?: string;
  items?: string[];
  acknowledgeLabel?: string;
}

interface UseActionDialogResult {
  dialog: ActionDialogPayload | null;
  showDialog: (payload: ActionDialogPayload) => void;
  hideDialog: () => void;
}

export function useActionDialog(initialDialog: ActionDialogPayload | null = null): UseActionDialogResult {
  const [dialog, setDialog] = useState<ActionDialogPayload | null>(initialDialog);

  const showDialog = useCallback((payload: ActionDialogPayload) => {
    setDialog(payload);
  }, []);

  const hideDialog = useCallback(() => {
    setDialog(null);
  }, []);

  return {
    dialog,
    showDialog,
    hideDialog,
  };
}
